import './FavoritesList.css';const favoritesList = "_favoritesList_1f0eg_1";
const favoritesList__buttonCol = "_favoritesList__buttonCol_1f0eg_5";
const styles = {
  favoritesList,
  favoritesList__buttonCol
};
export {
  styles as default,
  favoritesList,
  favoritesList__buttonCol
};
